import React from 'react'
import PropTypes from 'prop-types'
import { agnostify } from '@sainsburys-tech/boltui-utils'
import { onLinkClickFn } from '../../../helpers/ComponentHelper'
import * as Styled from './M032.styles'

/**
 * - M032 is a standalone CTA button designed for "SHOP ALL THINGS".
 * - It is not to be used for other types of links - for example to landing pages, or editorial content, so that customers associate it with shopping for products and it becomes instantly recognisable.
 */
const M032 = ({ backgroundColor, ctaCopy, full, kind, linkTarget, linkTitle, linkUrl, onLinkClick, noMargin }) => (
  <Styled.Container data-test='m032-container' noMargin={noMargin}>
    <Styled.M032Button
      data-test='m032-button'
      forwardedAs='a'
      backgroundColor={backgroundColor}
      href={agnostify(linkUrl)}
      target={linkTarget}
      title={linkTitle}
      onClick={(evt) => onLinkClickFn(evt, onLinkClick, linkUrl)}
      full={full}
      kind={kind}
    >
      {ctaCopy}
    </Styled.M032Button>
  </Styled.Container>
)

M032.propTypes = {
  /** Required color of the button's background */
  backgroundColor: PropTypes.string.isRequired,
  /** Required text for the CTA */
  ctaCopy: PropTypes.string.isRequired,
  /** Optional width of the button, defaults to false */
  full: PropTypes.bool,
  /** Type of button, defaults to primary */
  kind: PropTypes.oneOf(['primary', 'secondary']),
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  /** Required link title, can be seen when hovering over the CTA */
  linkTitle: PropTypes.string.isRequired,
  /** Required link url */
  linkUrl: PropTypes.string.isRequired,
  /** Optional function to handle CTA click */
  onLinkClick: PropTypes.func
}

M032.defaultProps = {
  full: false,
  kind: 'primary',
  linkTarget: '',
  onLinkClick: null,
  noMargin: false
}

export default M032
